import * as api from "../api/index";

import {
  ADD_NEW_STOCK,
  UPDATE_STOCK,
  DELETE_STOCK,
  DELETE_STOCKS,
  FETCH_STOCKS,
  FETCH_STOCK,
  START_LOADING,
  END_LOADING,
} from "./constants";

export const getAllStocks = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchStocks();
    console.log(data);
    dispatch({ type: FETCH_STOCKS, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

// export const getStocksByUser = (searchQuery) => async (dispatch) => {
//   try {
//     dispatch({ type: START_LOADING });
//     const {
//       data: { data },
//     } = await api.fetchStocksByUser(searchQuery);
//     dispatch({ type: FETCH_Stock_BY_USER, payload: data });
//     dispatch({ type: END_LOADING });
//   } catch (error) {
//     console.log(error.response);
//   }
// };

export const getStock = (id) => async (dispatch) => {
  const user = JSON.parse(localStorage.getItem("profile"));

  try {
    const { data } = await api.fetchStock(id);
    // console.log("getStockdata",data)
    // const businessDetails = await api.fetchProfilesByUser(user.result._id);
    // // console.log("Business Details: " ,businessDetails)
    // const StockData = { ...data, businessDetails };

    // console.log("Stock Data",StockData)
    dispatch({ type: FETCH_STOCK, payload: data });
  } catch (error) {
    console.log(error.response);
  }
};

export const createStock = (stock, history) => async (dispatch) => {
  try {
    
    console.log("Create Stock Called");
    dispatch({ type: START_LOADING });
    const  {data}  = await api.addStock(stock);
    console.log("Created Stock Data", data);
    dispatch({ type: ADD_NEW_STOCK, payload: data });
    
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const updateStock = (id, Stock) => async (dispatch) => {
  try {
    const { data } = await api.updateStock(id, Stock);
    dispatch({ type:  UPDATE_STOCK, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const deleteStock = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteStock(id);

    dispatch({ type:  DELETE_STOCK, payload: id });
    openSnackbar("Stock deleted successfully");
  } catch (error) {
    console.log(error.response);
  }
};
// export const deleteStockById = (id, type, openSnackbar) => async (dispatch) => {
//   try {
    
//     await api.deleteStockById(id, type);
//     dispatch({ type: DELETE_STOCKS, payload: { id, type } });
//     openSnackbar("Stocks deleted successfully");
//   } catch (error) {
//     console.log(error.response);
//   }
// };

// export const deleteStockById = (id, type, openSnackbar) => async (dispatch) => {
//   try {
//     const apiType = type === "SALES" ? "invoiceId" : type === "PURCHASE" ? "purchaseId" : null;
//     if (!apiType) {
//       throw new Error("Unsupported type for deletion");
//     }
//     await api.deleteStockById(id, apiType);
//     dispatch({ type: DELETE_STOCKS, payload: { id, type: apiType } });
//     openSnackbar("Stocks deleted successfully");
//   } catch (error) {
//     console.log(error.response || error.message);
//   }
// };

// export const deleteStockById = (id, type, openSnackbar) => async (dispatch) => {
//   try {
//     const apiType = 
//     type === "SALES" ? "invoiceId" : 
//     type === "PURCHASE" ? "purchaseId" : 
//     type === "STOCK_ADJUSTMENT" ? "stockAdjustmentId" : 
//     null;
//     if (!apiType) {
//       throw new Error("Unsupported type for deletion");
//     }
//     console.log(`Deleting stock with ${apiType}=${id}`);
//     await api.deleteStockById(id, apiType);
//     dispatch({ type: DELETE_STOCKS, payload: { id, type: apiType } });
//     openSnackbar("Stocks deleted successfully");
//   } catch (error) {
//     console.error("Delete Stock Error:", error.response?.data || error.message);
//     openSnackbar("Failed to delete stocks: " + (error.response?.data?.message || error.message));
//   }
// };

// export const deleteStockById = (id, type, openSnackbar) => async (dispatch) => {
//   try {
//     const apiType =
//       type === "SALES" ? "invoiceId" :
//       type === "PURCHASE" ? "purchaseId" :
//       type === "STOCK_ADJUSTMENT" ? "stockAdjustmentId" :
//       null;
//     if (!apiType) {
//       throw new Error("Unsupported type for deletion");
//     }
//     console.log(`Deleting stock with ${apiType}=${id}`);
//     const response = await api.deleteStockById(id, apiType); // Get response with deletedCount
//     dispatch({ type: DELETE_STOCKS, payload: { id, type: apiType } });
//     openSnackbar("Stocks deleted successfully");
//     return response.data; // Return { message, deletedCount }
//   } catch (error) {
//     console.error("Delete Stock Error:", error.response?.data || error.message);
//     openSnackbar("Failed to delete stocks: " + (error.response?.data?.message || error.message));
//     throw error;
//   }
// };

// export const deleteStockById = (id, type, openSnackbar) => async (dispatch) => {
//   try {
//     const apiType =
//       type === "SALES" ? "invoiceId" :
//       type === "PURCHASE" ? "purchaseId" :
//       type === "STOCK_ADJUSTMENT" ? "stockAdjustmentId" :
//       null;
//     if (!apiType) {
//       throw new Error("Unsupported type for deletion");
//     }
//     console.log(`Deleting stock with ${apiType}=${id}`);
//     const response = await api.deleteStockById(id, apiType); // Pass apiType (e.g., stockAdjustmentId)
//     dispatch({ type: DELETE_STOCKS, payload: { id, type: apiType } });
//     openSnackbar("Stocks deleted successfully");
//     return response.data; // Return { message, deletedCount }
//   } catch (error) {
//     console.error("Delete Stock Error:", error.response?.data || error.message);
//     openSnackbar("Failed to delete stocks: " + (error.response?.data?.message || error.message));
//     throw error;
//   }
// };

export const deleteStockById = (id, type) => async (dispatch) => {
  try {
    const apiType =
      type === "SALES" ? "invoiceId" :
      type === "PURCHASE" ? "purchaseId" :
      type === "STOCK_ADJUSTMENT" ? "stockAdjustmentId" :
      null;
    if (!apiType) {
      throw new Error("Unsupported type for deletion");
    }
    console.log(`Deleting stock with ${apiType}=${id}`);
    console.log("API Request:", `/stocks/${apiType}/${id}`);
    const response = await api.deleteStockById(id, apiType); // This calls the POST endpoint
    dispatch({ type: DELETE_STOCKS, payload: { id, type: apiType } });
    // openSnackbar("Stocks deleted successfully");
    return response.data; // Return { message, deletedCount }
  } catch (error) {
    console.error("Delete Stock Error:", error.response?.data || error.message);
    // openSnackbar("Failed to delete stocks: " + (error.response?.data?.message || error.message));
    throw error;
  }
};